import React, {Component}             from 'react'
import { Button, Form, Input, Modal, message } from 'antd'
import { checkAndSaveUsername }       from '../../services/purchase'

class PurchaseModal extends Component{
  constructor (props) {
    super(props)
    this._form = null
    this.state = {
      userStatus: null,
      marketingUrl: '',
      loading: false,
      count: 0
    }
    this._countDownTimer = null
  }

  handleChange = (values) => {
    if(values.hasOwnProperty('username')){
      this.setState({
        userStatus: null,
        marketingUrl: ''
      })
    }
  }

  handleSubmit = (values) => {
    const {username} = values
    if(username){
      this.setState({loading: true})
      const {inviteCode, sign, userType} = this.props.data
      checkAndSaveUsername({
        userType,
        inviteCode,
        username: username.trim(),
        sign
      }).then(res => {
        const { marketingUrl} = res
        this.setState({...res})
        marketingUrl ? this.startCountDown(() => {
          this.setState({loading: false})
          window.open(marketingUrl)
        }): this.setState({loading: false})
      }).catch(e => {
        message.error(e.errorMsg)
        this.setState({loading: false})
      })
    }
  }

  handleClose = () => {
    const {onClose} = this.props
    onClose && onClose()
    this.initModal()
  }

  initModal = () => {
    this.setState({
      userStatus: null,
      marketingUrl: '',
      loading: false,
      count: 0
    })
    this.clearTimer()
    this._form && this._form.resetFields(['username'])
  }

  clearTimer = () => {
    clearInterval(this._countDownTimer)
    this._countDownTimer = null
  }

  startCountDown = (callback) => {
    this.clearTimer()
    this.setState({count: 3})
    this._countDownTimer = setInterval(() => {
      let count = this.state.count - 1
      if(count === 0 ){
        this.clearTimer()
        callback && callback()
      }
      this.setState({count})
    }, 1000)
  }

  goUse = ()=> {
    const {data} = this.props
    window.open(data.href + '&state=' + data.inviteCode)
  }


  render () {
    const {visible, data} = this.props
    const {loading, count, userStatus} = this.state
    return (
      <Modal
        visible={visible}
        footer={null}
        className={'purchase__modal'}
        onCancel={this.handleClose}
        width={400}
      >
        <Form
          ref={ form => this._form = form}
          layout={'vertical'}
          className={'purchase__modal--form'}
          onValuesChange={this.handleChange}
          onFinish={this.handleSubmit}
        >
          <Form.Item
            className={'text-center'}
          >
            <p className={`purchase__icon purchase__icon--${data.key}`}></p>
          </Form.Item>
          <Form.Item
            label={['1688', 'taobao'].indexOf(data.key)>-1? '请输入订购旺旺': '输入订购店铺名'}
            name="username"
            rules={[
              {type: 'string',
                max: 30,
                min:1,
                message: '请输入正确的店铺名',
                validator: (_, value) => {
                  return (!value || !value.trim() || /^\d+$/.test(value)) ? Promise.reject(): Promise.resolve()
                }
              }
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            className={'text-center'}
          >
            { ['dy', 'jd'].indexOf(data.key) === -1 && <>
              {
                userStatus === true && <p className={'ant-form-item-explain-error'}>您输入的店铺未订购过灵通，即将前往订购</p>
              }
              {
                userStatus === false && <p className={'ant-form-item-explain-success'}>您输入的店铺已订购过灵通，即将前往订购</p>
              }
            </>}
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block disabled={loading} loading={loading}>
              { count ?`即将跳转，剩余${count}秒` :'确定'}
            </Button>
            <Button type="primary" ghost block
                    className={'mgt20'}
                    onClick={this.goUse}
            >已订购完成，去使用</Button>
          </Form.Item>
        </Form>
      </Modal>
    )
  }

}

export default PurchaseModal
